/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBrand } from './companyBrand';


export interface Company { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    acronym: string;
    brands?: Array<CompanyBrand>;
    brandCount?: number;
}

